<template>
  <el-input v-if="model" v-model="model[data.fieldId]" :type="data.type" :placeholder="data.placeholder" :prefix-icon="data.setting.prefixIcon" :suffix-icon="data.setting.suffixIcon" />
  <el-input v-else v-model="data.defaultValue" :type="data.type" :placeholder="data.placeholder" :prefix-icon="data.setting.prefixIcon" :suffix-icon="data.setting.suffixIcon" />
</template>

<script>
export default {
  name: 'HInput',
  props: {
    data: {
      type: Object,
      required: true
    },
    model: {
      type: [Object, null],
      default: null
    }
  }
}
</script>
